import { useParams } from 'react-router-dom';
import { useStore } from 'store/StoreContext';

export const useAccount = () => {
  const { accounts: accountsStore } = useStore();
  const params = useParams();
  return accountsStore.accounts.find(({ id }) => id === params.id);
};
